import { loaderConstants } from '../_constants';

export default function loader(state = {}, action) {
  switch (action.type) {
    case loaderConstants.START:
      return {
        loading: true,
      };
    case loaderConstants.STOP:
      return {
        loading: false,
      };
    case loaderConstants.CLEAR:
      return {};
    default:
      return state;
  }
}
